import { useState, useEffect } from 'react';
import { isAuthenticated, checkTokenValidity, clearAuthToken, setAuthToken } from '../utils/auth';

/**
 * Custom hook for managing authentication state
 * @returns {Object} Authentication state and handlers
 */
export const useAuthentication = () => {
  const [isAuthenticatedRight, setIsAuthenticatedRight] = useState(false);

  // Check authentication on mount
  useEffect(() => {
    if (!isAuthenticated()) {
      clearAuthToken();
      setIsAuthenticatedRight(false);
    } else {
      setIsAuthenticatedRight(true);
    }
  }, []);

  // Periodic token validation
  useEffect(() => {
    const interval = setInterval(async () => {
      const tokenIsValid = await checkTokenValidity();
      if (!tokenIsValid) {
        setIsAuthenticatedRight(false);
        clearAuthToken();
      }
    }, 90000); // Check every 1.5 minutes

    return () => clearInterval(interval);
  }, []);

  /**
   * Handles successful login
   * @param {string} token - JWT token from login
   */
  const handleLogin = (token) => {
    setAuthToken(token);
    setIsAuthenticatedRight(true);
  };

  /**
   * Handles logout
   */
  const handleLogout = () => {
    clearAuthToken();
    setIsAuthenticatedRight(false);
  };

  return {
    isAuthenticatedRight,
    handleLogin,
    handleLogout,
  };
};
